const Calendar = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path data-name="layer3" fill={color} d="M2 5h60v57H2z"></path>
    <path data-name="layer2" fill="white" d="M58 57.998H6v-49h52v49z"></path>
    <path data-name="layer2" fill={color} opacity=".35" d="M58 57.998H6v-49h52v49z"></path>
    <path
      data-name="layer1"
      d="M32 15a2 2 0 0 1-2-2V2a2 2 0 0 1 4 0v11a2 2 0 0 1-2 2zm-14 0a2 2 0 0 1-2-2V2a2 2 0 0 1 4 0v11a2 2 0 0 1-2 2zm28.022 0a2 2 0 0 1-2-2V2a2 2 0 0 1 4 0v11a2 2 0 0 1-2 2z"
      fill="#878787"
    ></path>
    <path
      data-name="opacity"
      fill="#000064"
      opacity=".15"
      d="M53 62H2V12.998l4-4v49h52L53 62z"
    ></path>
  </svg>
);

export default Calendar;
